import { type FloatingContext, useTransitionStyles } from '@floating-ui/react'

type FloatingTransitionOptions = {
  slideFrom?: 'above' | 'below'
  duration?: number
}

export const useFloatingTransition = (
  context: FloatingContext,
  options?: FloatingTransitionOptions
) => {
  const fromY = options?.slideFrom === 'above' ? '12px' : '-10px'

  return useTransitionStyles(context, {
    duration: options?.duration ?? 200,
    initial: {
      opacity: 0,
      transform: `translateY(${fromY})`
    },
    open: {
      opacity: 1,
      transform: 'translateY(0px)'
    },
    close: {
      opacity: 0,
      transform: `translateY(${fromY})`
    }
  })
}
